import React, { useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";

// styles
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// components
import PageTitle from "../../../components/PageTitle";
import FileUploader from "../../../components/FileUploader";
import { FormInput } from "../../../components/";

const AddOrganization = () => {
  const [editorState, setEditorState] = useState<any>();

  /*
   * form validation schema
   */
  const schemaResolver = yupResolver(
    yup.object().shape({
      name: yup.string().required("Please Enter Data"),
      branch: yup.string().required("Please Enter Data"),
      email: yup.string().required("Please Enter Data"),
      website: yup.string().required("Please Enter Data"),
      phone: yup.number().required("Please Enter Data"),
      fax: yup.number().required("Please Enter Data"),
      ownership: yup.string().required("Please Enter Data"),
      industry: yup.string().required("Please Enter Data"),
      orgtype: yup.string().required("Please Enter Data"),
      employees: yup.string().required("Please Enter Data"),
      assigned: yup.string().required("Please Enter Data"),
      billingaddr: yup.string().required("Please Enter Data"),
      shippingaddr: yup.string().required("Please Enter Data"),
      billingpobox: yup.number().required("Please Enter Data"),
      shippingpobox: yup.number().required("Please Enter Data"),
      billingcity: yup.string().required("Please Enter Data"),
      shippingcity: yup.string().required("Please Enter Data"),
      billingstate: yup.string().required("Please Enter Data"),
      shippingstate: yup.string().required("Please Enter Data"),
      billpostcode: yup.number().required("Please Enter Data"),
      shipppostcode: yup.number().required("Please Enter Data"),
      billingcountry: yup.string().required("Please Enter Data"),
      shippingcountry: yup.string().required("Please Enter Data"),
    })
  );

  /*
   * form methods
   */
  const methods = useForm({ resolver: schemaResolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  /**
   * On editor body change
   */
  const onEditorStateChange = (editorStates: any) => {
    setEditorState(editorStates);
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Ecommerce", path: "/apps/ecommerce/details" },
          {
            label: "Organization",
            path: "/apps/ecommerce/details",
            active: true,
          },
        ]}
        title={"Add Organization"}
      />

      <form onSubmit={handleSubmit(() => {})}>
        <Row>
          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase bg-light p-2 mt-0 mb-3">
                  General Information
                </h5>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="name"
                      label="Organization Name"
                      placeholder="e.g : Apple iMac"
                      containerClass={"mb-3"}
                      register={register}
                      key="name"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="branch"
                      label="Branch"
                      placeholder="e.g : LHR"
                      containerClass={"mb-3"}
                      register={register}
                      key="branch"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="email"
                      label="Email"
                      placeholder="e.g : as@gmail.com"
                      containerClass={"mb-3"}
                      register={register}
                      key="email"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="website"
                      label="Website"
                      placeholder="e.g : www.youtube.com"
                      containerClass={"mb-3"}
                      register={register}
                      key="websit"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="phone"
                      label="Phone No"
                      placeholder="e.g : 012345"
                      containerClass={"mb-3"}
                      register={register}
                      key="phone"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="fax"
                      label="Fax"
                      placeholder="e.g : 06821234"
                      containerClass={"mb-3"}
                      register={register}
                      key="fax"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="ownership"
                      label="Ownership"
                      placeholder="e.g : Apple iMac"
                      containerClass={"mb-3"}
                      register={register}
                      key="ownership"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="industry"
                      label="Industry"
                      placeholder="e.g : Apple iMac"
                      containerClass={"mb-3"}
                      register={register}
                      key="industry"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase mt-0 mb-3 bg-light p-2">
                  Product Images
                </h5>
                <FileUploader />
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase bg-light p-2 mt-0 mb-3">
                  Lead Information
                </h5>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="shippingpobox"
                      label="Shipping PO Box"
                      placeholder="e.g : 5627"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingpobox"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="organization"
                      label="Organization Type"
                      placeholder="e.g : Software"
                      containerClass={"mb-3"}
                      register={register}
                      key="orgtype"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="employees"
                      label="Number of Employees"
                      placeholder="e.g : 150"
                      containerClass={"mb-3"}
                      register={register}
                      key="employees"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="assigned"
                      label="Assigned To"
                      placeholder="e.g : Hammad"
                      containerClass={"mb-3"}
                      register={register}
                      key="assigned"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billingaddr"
                      label="Billing Address"
                      placeholder="e.g : Model town LHR"
                      containerClass={"mb-3"}
                      register={register}
                      key="billingaddr"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="Shippingaddr"
                      label="Shipping Address"
                      placeholder="e.g : Faizabad Rawalpindi"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingaddr"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billingpobox"
                      label="Billing PO Box"
                      placeholder="e.g : 2050"
                      containerClass={"mb-3"}
                      register={register}
                      key="billingpobox"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="shippingpobox"
                      label="Shipping PO Box"
                      placeholder="e.g : 5627"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingpobox"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <label className="mb-2">Notify Owner</label>
                <div className="d-flex flex-wrap">
                  <FormInput
                    type="radio"
                    name="radioInline"
                    label="Yes"
                    value="option1"
                    containerClass={"me-2"}
                    defaultChecked
                    register={register}
                    key="inlineRadio1"
                    errors={errors}
                    control={control}
                  />
                  <FormInput
                    type="radio"
                    name="radioInline"
                    label="No"
                    value="option2"
                    containerClass={"me-2"}
                    register={register}
                    key="inlineRadio2"
                    errors={errors}
                    control={control}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase bg-light p-2 mt-0 mb-3">
                  Address Details
                </h5>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billingcity"
                      label="Billing City"
                      placeholder="e.g : LHR"
                      containerClass={"mb-3"}
                      register={register}
                      key="billingcity"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="shippingcity"
                      label="Shipping City"
                      placeholder="e.g : Gawader"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingcity"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billingstate"
                      label="Billing State"
                      placeholder="e.g : PU"
                      containerClass={"mb-3"}
                      register={register}
                      key="billingstate"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="shippingstate"
                      label="Shipping State"
                      placeholder="e.g : SI"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingstate"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billpostcode"
                      label="Billing Postal Code"
                      placeholder="e.g : 2331"
                      containerClass={"mb-3"}
                      register={register}
                      key="billpostcode"
                      errors={errors}
                      control={control}
                    />
                  </Col>

                  <Col md={6}>
                    <FormInput
                      name="shipppostcode"
                      label="Shipping Postal Code"
                      placeholder="e.g : 4345"
                      containerClass={"mb-3"}
                      register={register}
                      key="shipppostcode"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="billingcountry"
                      label="Billing Country"
                      placeholder="e.g : Pakistan"
                      containerClass={"mb-3"}
                      register={register}
                      key="billingcountry"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="shippingcountry"
                      label="Shipping Country"
                      placeholder="e.g : Iran"
                      containerClass={"mb-3"}
                      register={register}
                      key="shippingcountry"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase mt-0 mb-3 bg-light p-2">
                  DESCRIPTION
                </h5>
                <Form.Group className="mb-3">
                  <Editor
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName border border-1"
                    editorClassName="editorClassName px-2"
                    onEditorStateChange={onEditorStateChange}
                    editorStyle={{ minHeight: "150px" }}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="text-center mb-3">
              <button
                type="button"
                className="btn w-sm btn-light waves-effect me-1"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn w-sm btn-success waves-effect waves-light me-1"
              >
                Save
              </button>
              <button
                type="button"
                className="btn w-sm btn-danger waves-effect waves-light me-1"
              >
                Delete
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddOrganization;
